import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import apiInstance from '../../utils/axios';
import { Link } from 'react-router-dom';
import ProductCard from '../../components/ProductCard';


const MostViewedCarousel = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Handle responsive breakpoint
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  useEffect(() => {
    const fetchMostViewedProducts = async () => {
      try {
        // Use new Produtos Mais Vistos endpoint
        const response = await apiInstance.get('produtos-mais-vistos/');
        let productsData = Array.isArray(response.data) ? response.data : (response.data.results || []);
        
        const productsWithNumericPrices = productsData.map(product => ({
          ...product,
          price: typeof product.price === 'number' ? product.price : Number(product.price) || 0,
          old_price: product.old_price 
            ? (typeof product.old_price === 'number' ? product.old_price : Number(product.old_price) || 0)
            : null
        }));
        setProducts(productsWithNumericPrices);
      } catch (error) {
        console.error('Error fetching Produtos Mais Vistos:', error);
        // Fallback to old endpoint on error
        try {
          const fallbackResponse = await apiInstance.get('most-viewed-products/');
          const productsData = Array.isArray(fallbackResponse.data) ? fallbackResponse.data : (fallbackResponse.data.results || []);
          const productsWithNumericPrices = productsData.map(product => ({
            ...product,
            price: typeof product.price === 'number' ? product.price : Number(product.price) || 0,
            old_price: product.old_price 
              ? (typeof product.old_price === 'number' ? product.old_price : Number(product.old_price) || 0)
              : null
          }));
          setProducts(productsWithNumericPrices);
        } catch (fallbackError) {
          console.error('Fallback also failed:', fallbackError);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMostViewedProducts();
  }, []);

  const ArrowButton = ({ direction, onClick }) => (
    <button
      onClick={onClick}
      style={{
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        [direction === 'prev' ? 'left' : 'right']: '-15px',
        background: 'white',
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        border: '2px solid #f0f0f0',
        cursor: 'pointer',
        zIndex: 10,
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
        e.currentTarget.style.boxShadow = '0 6px 20px rgba(52, 131, 250, 0.4)';
        e.currentTarget.style.background = '#3483fa';
        e.currentTarget.style.borderColor = '#3483fa';
        e.currentTarget.querySelector('path').style.stroke = 'white';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
        e.currentTarget.style.background = 'white';
        e.currentTarget.style.borderColor = '#f0f0f0';
        e.currentTarget.querySelector('path').style.stroke = '#3483fa';
      }}
      aria-label={direction === 'prev' ? 'Previous' : 'Next'}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path 
          d={direction === 'prev' ? "M15 18L9 12L15 6" : "M9 18L15 12L9 6"} 
          stroke="#3483fa" 
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );

  const settings = {
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 6, // Show 6 cards at once
    slidesToScroll: 6, // Move 6 slides at a time
    arrows: true,
    prevArrow: <ArrowButton direction="prev" />,
    nextArrow: <ArrowButton direction="next" />,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6, // Move 6 slides at a time
          arrows: true,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4, // Move 4 slides at a time
          arrows: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2, // Move 2 slides at a time for 2x2 grid
          arrows: false, // Hide arrows on mobile
          dots: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2, // Move 2 slides at a time for 2x2 grid
          arrows: false, // Hide arrows on mobile
          dots: true,
        }
      }
    ]
  };

  if (loading) {
    return (
      <div style={{
        maxWidth: '1200px',
        margin: '40px auto',
        padding: '0 20px',
        height: '300px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '3px solid #f3f3f3',
          borderTop: '3px solid #3483fa',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
      </div>
    );
  }

  return (
    <div style={{
      maxWidth: '1200px',
      margin: '80px auto',
      padding: '32px',
      overflow: 'hidden',
      backgroundColor: 'white',
      borderRadius: '16px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      border: '1px solid #f0f0f0',
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    }}
    className="most-viewed-carousel-container"
    onMouseEnter={(e) => {
      e.currentTarget.style.boxShadow = '0 8px 40px rgba(0,0,0,0.12)';
      e.currentTarget.style.borderColor = '#e0e7ff';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
      e.currentTarget.style.borderColor = '#f0f0f0';
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        marginBottom: '40px',
        padding: '0'
      }}>
        <div>
          <h2 style={{
            fontSize: '28px',
            fontWeight: '500',
            color: '#333',
            margin: '0 0 8px 0',
          }}>Más vistos</h2>
          <p style={{
            fontSize: '16px',
            color: '#666',
            margin: 0,
          }}>Estos productos son tendencia ahora mismo</p>
        </div>
        <Link to="/products" style={{
          color: '#333',
          textDecoration: 'none',
          fontSize: '14px',
          fontWeight: '500',
          padding: '8px 0',
          borderBottom: '2px solid #333',
          transition: 'all 0.3s ease',
        }}
        onMouseEnter={(e) => {
          e.target.style.borderBottomColor = '#00a650';
          e.target.style.color = '#00a650';
        }}
        onMouseLeave={(e) => {
          e.target.style.borderBottomColor = '#333';
          e.target.style.color = '#333';
        }}
        >Ver todo</Link>
      </div>

      {/* Mobile: Grid Layout (like Productos populares) */}
      {isMobile ? (
        <div className="most-viewed-grid" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: '12px',
          padding: '0',
        }}>
          {products && products.slice(0, 8).map((product) => (
            <ProductCard key={product.id} product={product} variant="compact" />
          ))}
        </div>
      ) : (
        /* Desktop: Slider */
        <div style={{ 
          position: 'relative',
          width: '100%',
          margin: '0 auto',
          padding: '0'
        }}>
          <Slider {...settings}>
            {products && products.map((product) => (
              <div key={product.id} style={{ 
                padding: '0 4px',
                outline: 'none',
              }}>
                <ProductCard 
                  product={product} 
                  variant="compact"
                />
            </div>
          ))}
        </Slider>
        </div>
      )}
      
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          /* Custom carousel styling for better spacing */
          .slick-slide {
            padding: 0 2px !important;
          }
          
          .slick-track {
            display: flex !important;
            align-items: stretch !important;
          }
          
          .slick-slide > div {
            height: 100%;
            display: flex;
            align-items: stretch;
          }

          /* Mobile Responsiveness */
          @media (max-width: 768px) {
            .most-viewed-carousel-container {
              padding: 12px !important;
              margin: 16px 8px !important;
              border-radius: 12px !important;
              box-shadow: 0 2px 12px rgba(0,0,0,0.08) !important;
              max-width: calc(100% - 16px) !important;
            }
            
            .most-viewed-carousel-container > div:first-child {
              margin-bottom: 16px !important;
              flex-direction: column !important;
              align-items: flex-start !important;
              gap: 8px !important;
            }
            
            .most-viewed-carousel-container h2 {
              font-size: 18px !important;
              margin-bottom: 2px !important;
            }
            
            .most-viewed-carousel-container p {
              font-size: 12px !important;
            }
            
            .slick-slide {
              padding: 0 4px !important;
            }
            
            .slick-slide > div {
              height: auto !important;
            }
            
            .slick-dots {
              bottom: -24px !important;
            }
            
            .slick-dots li {
              margin: 0 2px !important;
            }
            
            .slick-dots li button:before {
              font-size: 8px !important;
              color: #3483fa !important;
            }
          }
          
          @media (max-width: 480px) {
            .most-viewed-carousel-container {
              padding: 10px !important;
              margin: 12px 6px !important;
              border-radius: 10px !important;
              max-width: calc(100% - 12px) !important;
            }
            
            .most-viewed-carousel-container h2 {
              font-size: 16px !important;
              line-height: 1.2 !important;
            }
            
            .most-viewed-carousel-container p {
              font-size: 11px !important;
            }
            
            .slick-slide {
              padding: 0 3px !important;
            }
            
            .slick-dots {
              bottom: -20px !important;
            }
          }
          
          /* Mobile Product Card Price Visibility */
          @media (max-width: 768px) {
            .most-viewed-carousel-container .product-card-compact {
              min-height: 280px !important;
              height: auto !important;
            }
            
            .most-viewed-carousel-container .product-card-compact .product-content {
              min-height: 120px !important;
              padding: 10px !important;
            }
            
            .most-viewed-carousel-container .product-card-compact .price {
              font-size: 16px !important;
              font-weight: 700 !important;
              display: block !important;
              color: #1a1a1a !important;
              visibility: visible !important;
              opacity: 1 !important;
            }
          }
          
          @media (max-width: 480px) {
            .most-viewed-carousel-container .product-card-compact {
              min-height: 260px !important;
            }
            
            .most-viewed-carousel-container .product-card-compact .product-content {
              min-height: 110px !important;
              padding: 8px !important;
            }
            
            .most-viewed-carousel-container .product-card-compact .price {
              font-size: 15px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default MostViewedCarousel;